// extracted by mini-css-extract-plugin
export default {"panel":"aNxPq1","geoGroup":"bNxPq1"};